module.exports = __webpack_public_path__ + "img/d2.2d553b44.jpg";